import { Children, cloneElement, ReactElement } from 'react';

export const FIELD_REQUIRED = 'Field required';
export const INVALID_EMAIL = 'This email has invalid format';
export const EMAIL_IS_REQUIRED = 'Email is required';

export const getMinLength = (length: number) => `Must be at least ${length} characters`;
export const getMaxLength = (length: number) => `Must be at most ${length} characters`;

export const phoneRegExp = /^[3-9]\d{9}$/;

export const ifscRegExp = /^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/;

export const mobileDeviceChecker = /Android|iPhone/i.test(navigator.userAgent);

export const extractSlugFromUrl = (url: string): string | null => {
  const regex = /\/p\/([^/]+)/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

type JSXElement = ReactElement | string;

export const decodeHtmlEntities = (str: string): string => {
  const htmlEntities: Record<string, string> = {
    '&nbsp;': ' ',
    '&lt;': '<',
    '&gt;': '>',
    '&amp;': '&',
    '&quot;': '"',
    '&apos;': "'",
    '&#39;': "'",
    '&ndash;': '–',
    '&mdash;': '—',
    '&hellip;': '…',
    '&trade;': '™',
    '&copy;': '©',
    '&reg;': '®',
    '&plusmn;': '±',
    '&ge;': '≥',
    '&le;': '≤',
    '&ne;': '≠',
    '&times;': '×',
    '&divide;': '÷',
    '&#x2f;': '/',
  };

  const entityPattern = new RegExp(Object.keys(htmlEntities).join('|'), 'g');

  return str.replace(entityPattern, (match) => htmlEntities[match] || match);
};

const decodeJSXElement = (element: JSXElement): JSXElement => {
  if (typeof element === 'string') {
    return decodeHtmlEntities(element);
  }

  const decodedChildren = Children.map(element.props.children, decodeJSXElement);

  return cloneElement(element, { ...element.props, children: decodedChildren });
};

export const decodeHtmlEntitiesFromJSX = (element: JSXElement): JSXElement => {
  return decodeJSXElement(element);
};

export const getDomain = (url: string) => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.origin; // Возвращает протокол + домен
  } catch (e) {
    console.error('Invalid URL', e);
    return null;
  }
};
